import { ITypeColor } from "../../../utils/selectColors";

export enum EPredictiveType {
  multi = "multi",
  binary = "binary",
}

export enum EOptionType {
  positive = "positive",
  negative = "negative",
  neutral = "neutral",
}

export interface IOption {
  value: number;
  text: string;
  id: number;
}
export interface IOptions {
  title: string;
  type: EOptionType;
  probability?: number;
  yes: IOption;
  no: IOption;
}
export interface IPredictiveData {
  id: number;
  title: string;
  info: string;
  icon: string;
  type: EPredictiveType;
  options: IOptions[];
  optionsPrefer?: IOptions[];
}

export const variantColors: Record<EOptionType, ITypeColor> = {
  neutral: { bg: "#E9F8EB", color: "#23BD32" },
  negative: { bg: "#EAE8F1", color: "#2C1B73" },
  positive: { bg: "#FCE8EB", color: "#E3183B" },
};

export const MOCK_PREDICTIVES_LIST: IPredictiveData[] = [
  {
    id: 1,
    title: "Qual será o resultado da decisão do COPOM?",
    info: "Reunião Copom 04 - 05 Nov. 2025",
    icon: "bank",
    type: EPredictiveType.multi,
    options: [
      {
        title: "Queda 1%",
        probability: 23,
        type: EOptionType.negative,
        yes: { value: 23, text: "R$23", id: 1 },
        no: { value: 45, text: "R$45", id: 2 },
      },
      {
        title: "Queda 0,75%",
        probability: 23,
        type: EOptionType.negative,
        yes: { value: 23, text: "R$23", id: 3 },
        no: { value: 45, text: "R$45", id: 4 },
      },
      {
        title: "Queda 0,50%",
        probability: 23,
        type: EOptionType.negative,
        yes: { value: 23, text: "R$23", id: 5 },
        no: { value: 45, text: "R$45", id: 6 },
      },
      {
        title: "Queda 0,25%",
        probability: 23,
        type: EOptionType.negative,
        yes: { value: 23, text: "R$23", id: 7 },
        no: { value: 45, text: "R$45", id: 8 },
      },
      {
        title: "Manutenção",
        type: EOptionType.neutral,
        probability: 89,
        yes: { value: 23, text: "R$23", id: 9 },
        no: { value: 45, text: "R$45", id: 10 },
      },
      {
        title: "Aumento 0,25%",
        probability: 48,
        type: EOptionType.positive,

        yes: { value: 23, text: "R$23", id: 11 },
        no: { value: 45, text: "R$45", id: 12 },
      },
      {
        title: "Aumento 0,50%",
        probability: 48,
        type: EOptionType.positive,
        yes: { value: 23, text: "R$23", id: 13 },
        no: { value: 45, text: "R$45", id: 14 },
      },
      {
        title: "Aumento 0,75%",
        probability: 48,
        type: EOptionType.positive,
        yes: { value: 23, text: "R$23", id: 15 },
        no: { value: 45, text: "R$45", id: 16 },
      },
      {
        title: "Aumento 1%",
        probability: 48,
        type: EOptionType.positive,
        yes: { value: 23, text: "R$23", id: 17 },
        no: { value: 45, text: "R$45", id: 18 },
      },
    ],
    optionsPrefer: [
      {
        title: "Queda 0,25%",
        probability: 23,
        type: EOptionType.negative,
        yes: { value: 23, text: "R$23", id: 7 },
        no: { value: 45, text: "R$45", id: 8 },
      },
      {
        title: "Manutenção",
        type: EOptionType.neutral,
        probability: 89,
        yes: { value: 23, text: "R$23", id: 9 },
        no: { value: 45, text: "R$45", id: 10 },
      },
    ],
  },
  {
    id: 2,
    title: "Índice BOVESPA fechará acima de 160 mil?",
    info: "Reunião fechamento dia 12 de Novembro",
    icon: "chart",
    type: EPredictiveType.binary,
    options: [
      {
        title: "Fechar acima",
        type: EOptionType.neutral,
        yes: { value: 90, text: "R$90", id: 19 },
        no: { value: 10, text: "R$10", id: 20 },
      },
    ],
  },
  {
    id: 3,
    title: "Petrobras irá fechar acima de R$40?",
    info: "Reunião fechamento dia 21 de Novembro",
    icon: "br-petr4",
    type: EPredictiveType.binary,
    options: [
      {
        title: "Fechar acima",
        type: EOptionType.neutral,
        yes: { value: 88, text: "R$88", id: 21 },
        no: { value: 12, text: "R$12", id: 22 },
      },
    ],
  },
  {
    id: 4,
    title: "Qual será o valor da ABEV3 até o fechamento?",
    info: "Reunião fechamento dia 21 de Novembro",
    icon: "abev3",
    type: EPredictiveType.multi,
    options: [
      {
        title: "R$13,70",
        type: EOptionType.neutral,
        yes: { value: 58, text: "R$58", id: 23 },
        no: { value: 20, text: "R$20", id: 24 },
      },
      {
        title: "R$13,50",
        type: EOptionType.neutral,
        yes: { value: 95, text: "R$95", id: 25 },
        no: { value: 5, text: "R$5", id: 26 },
      },
    ],
    optionsPrefer: [
      {
        title: "R$13,70",
        type: EOptionType.neutral,
        yes: { value: 58, text: "R$58", id: 23 },
        no: { value: 20, text: "R$20", id: 24 },
      },
      {
        title: "R$13,50",
        type: EOptionType.neutral,
        yes: { value: 95, text: "R$95", id: 25 },
        no: { value: 5, text: "R$5", id: 26 },
      },
    ],
  },
  {
    id: 5,
    title: "Qual será o valor da ABEV3 até o fechamento?",
    info: "Reunião fechamento dia 21 de Novembro",
    icon: "abev3",
    type: EPredictiveType.multi,
    options: [
      {
        title: "R$13,70",
        type: EOptionType.neutral,
        yes: { value: 58, text: "R$58", id: 27 },
        no: { value: 20, text: "R$20", id: 28 },
      },
      {
        title: "R$13,50",
        type: EOptionType.neutral,
        yes: { value: 95, text: "R$95", id: 29 },
        no: { value: 5, text: "R$5", id: 30 },
      },
    ],
    optionsPrefer: [
      {
        title: "R$13,70",
        type: EOptionType.neutral,
        yes: { value: 58, text: "R$58", id: 27 },
        no: { value: 20, text: "R$20", id: 28 },
      },
      {
        title: "R$13,50",
        type: EOptionType.neutral,
        yes: { value: 95, text: "R$95", id: 29 },
        no: { value: 5, text: "R$5", id: 30 },
      },
    ],
  },
  {
    id: 6,
    title: "Qual será o valor da ABEV3 até o fechamento?",
    info: "Reunião fechamento dia 21 de Novembro",
    icon: "abev3",
    type: EPredictiveType.binary,
    options: [
      {
        title: "R$13,70",
        type: EOptionType.neutral,
        yes: { value: 58, text: "R$58", id: 31 },
        no: { value: 20, text: "R$20", id: 32 },
      },
    ],
  },
];
